import { IScrollablePaneStyles, IStyle } from '@fluentui/react';
import { ICorptaxTheme } from '../ICorptaxTheme';
import { IPinnedContainerStyles } from './IPinnedContainerStyles';

export class CorptaxThemePinnedContainerStyles implements IPinnedContainerStyles {
    constructor(
        private theme: ICorptaxTheme,
        private width: number,
        private scrollbarStyles: IStyle,
        private siteHeaderHeight: number
    ) {}

    get containerDiv(): IStyle {
        return {
            width: `${this.width}px`,
            position: 'relative',
            marginLeft: 4,
            maxHeight: 'inherit',
            height: `calc(100vh - ${this.siteHeaderHeight}px)`,
            borderRight: `3px solid ${this.theme.extendedPalette.accent}`,
        };
    }

    get scrollablePane(): Partial<IScrollablePaneStyles> {
        return {
            contentContainer: {
                ...(this.scrollbarStyles as object),
            },
        };
    }
}
